const debug = false;

export default class TextBoxRenderer
{


  render(ctx, text, font, x, y, width, suffix)
  {

    if (!suffix) { suffix = '...';}

    // ctx.beginPath();
    // ctx.rect(x,y,width,font.getSize());
    // ctx.strokeStyle = 'white';
    // ctx.stroke();

    let iteration = 0;
    ctx.font = font;

    while (this.getStringWidth(ctx, text + (iteration > 0  ? suffix : '')) > width) {

      text = text.substring(0, text.length - 1);
      iteration++;

    }

    if (debug) {
      ctx.save();
      ctx.beginPath();
      ctx.rect(x, y, width, font.getSize());
      ctx.fillStyle = 'red';
      ctx.fill();
      ctx.restore();
    }

    text = text + (iteration > 0  ? suffix : '');

    ctx.fillText(text, x, y + font.getSize());

    return [this.getStringWidth(ctx, text), iteration]
  }

  getStringWidth(ctx, text) {
    let measured = ctx.measureText(text);
    return measured.width;
  }

}
